'use strict';

var React = require('react');

var SvgMergeMinor = function SvgMergeMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 2a1 1 0 0 0-.717.303l-5 5.143a1 1 0 0 0 1.434 1.394l3.283-3.377v6.537a1 1 0 0 0 .293.707l5 5a1 1 0 0 0 1.414-1.414l-4.707-4.707v-6.123l3.283 3.377a1 1 0 0 0 1.434-1.394l-5-5.143a1 1 0 0 0-.717-.303Zm-2.293 12.293a1 1 0 0 0-1.414 0l-2 2a1 1 0 1 0 1.414 1.414l2-2a1 1 0 0 0 0-1.414Z"
  }));
};

exports.SvgMergeMinor = SvgMergeMinor;
